import { isFeatureEnabled } from 'owa-feature-flags';
import { FeatureNames, FlightNames } from 'owa-mail-smart-pill-features';
import { SmartPillData } from 'owa-smart-pill';
import { trace } from 'owa-trace';

export default function isPillTypeEnabled(pill: SmartPillData): boolean {
    const featureName: string = pill.featureName;

    if (featureName === FeatureNames.SmartReply) {
        return isFeatureEnabled(FlightNames.SmartReply);
    }

    if (featureName === FeatureNames.SmartTime) {
        return isFeatureEnabled(FlightNames.SmartReplyWithCustomMeetingTime);
    }

    if (featureName === FeatureNames.SmartDoc) {
        return isFeatureEnabled(FlightNames.SmartDoc);
    }

    // We don't have any other pill types, so if we're here, log a trace and return false.
    trace.info(`[isPillTypeEnabled] Unknown pill type: ${featureName}`);
    return false;
}
